import { forwardRef, useRef, useEffect } from "react";
import {
  useTextField,
  VisuallyHidden,
  type AriaTextFieldProps,
} from "react-aria";
import styles from "./FormInput.module.css";

export const DEFAULT_GROUP_LABEL = "Untitled group";

interface FormInputProps extends AriaTextFieldProps {
  maxLength?: number;
  onSubmit: () => void;
}
export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  function AssetControlInputForm(props, ref) {
    const { label, value } = props;

    const innerRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
      if (typeof ref === "function") {
        ref(innerRef.current);
      } else if (ref) {
        ref.current = innerRef.current;
      }
    }, [ref]);

    // Dynamically adjust input width based on content
    useEffect(() => {
      if (innerRef.current) {
        const text = String(value || "");
        // Create a temporary span to measure text width
        const span = document.createElement("span");
        span.style.font = getComputedStyle(innerRef.current).font;
        span.style.visibility = "hidden";
        span.style.position = "absolute";
        span.textContent = text || DEFAULT_GROUP_LABEL;
        document.body.appendChild(span);
        const textWidth = span.getBoundingClientRect().width;
        document.body.removeChild(span);

        // Add buffer for cursor (CSS min-width ensures minimum of 100px)
        const width = textWidth + 4;
        innerRef.current.style.width = `${width}px`;
      }
    }, [value]);

    const { labelProps, inputProps } = useTextField(props, innerRef);

    return (
      <form onSubmit={props.onSubmit} className={styles.form}>
        <VisuallyHidden>
          <label {...labelProps} htmlFor="asset-rename">
            {label}
          </label>
        </VisuallyHidden>
        <input
          {...inputProps}
          ref={innerRef}
          className={styles.input}
          id="asset-rename"
          name="asset-rename"
          maxLength={props.maxLength}
        />
      </form>
    );
  },
);
